export type PageActionEntity = 'create' | 'update' | 'duplicate' | 'detail';
export enum SORTER_TYPE {
  'descend' = 'DESC',
  'ascend' = 'ASC',
}
